export default __webpack_public_path__ + "static/media/Residentialcareworker-01.b792afdf.png";